module.exports = __webpack_public_path__ + "img/landshut_afraaltar.64ec4466.jpg";